module.exports = __webpack_public_path__ + "img/天南星.983e7f07.jpg";